module.exports = __webpack_public_path__ + "assets/img/34_771.ac62853c.jpg";